import i18n from 'i18next';
import { toast } from 'react-toastify';
import API_BASE_URL from 'src/constants';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logger from 'src/utils/logger';
import { beginSession } from './session';

interface LoginResponse {
  access_token: string;
  user: {
    id: string;
    email: string;
  };
}

const postRequest = async <T>(url: string, body: object): Promise<T> => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json() as Promise<T>;
};

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  return postRequest<LoginResponse>(`${API_BASE_URL}portal/login`, {
    login: email,
    password,
  });
};

export const useLogin = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSubmit = async (email: string, password: string) => {
    setLoading(true);
    try {
      const data = await login(email, password);
      // Resets the query cache / redux before the token is written, so the new
      // user can never be served the previous user's cached data (access
      // rights above all) on the first render.
      beginSession(data.access_token);
      navigate('/dashboard', { replace: true });
    } catch (error) {
      logger.error('Login failed', error);
      toast.error(i18n.t('errors.login_failed'));
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    loading,
  };
};

export default useLogin;
